import {ActionTree} from "vuex";
import axios from 'axios';
import {TemplateParamFilter, TemplateParamsState, TemplateParamsItem} from "@/store/settings/template_params/types";
import {RootState} from "@/store/types";

export const actions: ActionTree<TemplateParamsState, RootState> = {
  async getTemplateParams({commit}, data: TemplateParamFilter) {
    try {
      const resp = await axios({
        url: '/acapi/distribution/template/params',
        params: {
          transport: data?.transport,
          name: data?.name,
          partner_id: data?.partner_id,
          partner_name: data?.partner_name,
          page_number: data?.page_number,
        },
      });

      if (data?.page_number > 1) {
        commit("pushTemplateParams", resp.data);
      } else {
        commit('setTemplateParams', resp.data);
      }
      return resp.data;
    }
    finally {
      commit('setLoading', false);
    }
  },
  getTemplateParamsItem: async ({commit}, id) => {
    commit('setLoading', true);
    try {
      let resp = await axios({url: `/acapi/distribution/template/params/${id}`});
      let templateParamsItem = <TemplateParamsItem> resp.data;
      templateParamsItem.id = id;
      commit('setTemplateParamsItem', templateParamsItem);
      return templateParamsItem;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
  saveTemplateParamsItem: async ({commit, dispatch}, data: TemplateParamsItem) => {
    commit('setLoading', true);
    try {
      let resp = await axios({
        method: data.id ? 'put' : 'post',
        url: '/acapi/distribution/template/params/' + (data.id ?? ''),
        data: data
      });
      await dispatch('getTemplateParams');
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
  deleteTemplateParamsItem: async ({commit, dispatch}, data: TemplateParamsItem) => {
    commit('setLoading', true);
    try {
      let resp = await axios({
        method: 'delete',
        url: `/acapi/distribution/template/params/${data.id}`,
        data: data
      });
      await dispatch('getTemplateParams');
      return resp;
    } catch (err) {
      throw err;
    } finally {
      commit('setLoading', false);
    }
  },
}
